import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {MatButtonModule} from '@angular/material/button';

import {MatCardModule} from '@angular/material/card';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatCardModule, MatButtonModule]
})
export class ErrorComponent implements OnInit {

  errorId: string;

  constructor(private _activatedRoute: ActivatedRoute, private _router: Router) { }

  ngOnInit() {
    this.errorId = this._activatedRoute.snapshot.queryParamMap.get('errorId');
  }

  reloadApp() {
    this._router.navigate(['/']);
  }
}
